import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface DurationEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
    durationTimeUnit?: string;
}

export function DurationEntryValue({ value, inputLabel, durationTimeUnit, ...props }: DurationEntryValueProps) {
    return (
        <BaseEntryValue inputLabel={inputLabel} {...props}>
            <p>
                {value} {durationTimeUnit || ""}
            </p>
        </BaseEntryValue>
    );
}
